module.exports = __webpack_public_path__ + "img/lock.d485f504.svg";